<template>
    <div>

    <template v-if="orientation=='portrait'">

        
                            <div style="font-size:13px;font-weight: 600;padding-top:25px;padding:4%">

                                <div class="qhighlight" style="border-radius:5px;padding:8px;margin:10px">
                                    <router-link :to="{ name: 'graph' }"  style="color: black" >
                                        <div style="color:white;"><img class="qlargeiconsize qbordericon" :src="require('/public/assets/icons/bet-whi.png')" alt="" id="img0"></div>
                                        <div style="margin-top:10px;margin-bottom:10px" id="title0">{{ langConv('We publish our bets and strategies for you to view') }}</div>
                                    </router-link>
                                </div>
                                
                                <div class="qhighlight" style="border-radius:5px;padding:8px;margin:10px">
                                    <router-link :to="{ name: 'oddsanalysis' }"  style="color: black" >
                                         <div><img class="qlargeiconsize qbordericon" :src="require('/public/assets/icons/analytics-whi.png')" alt="" ></div>
                                         <div style="margin-top:10px;margin-bottom:10px" id="title1">{{ langConv('We analyse the odds to help with different betting strategies') }}</div>
                                    </router-link>
                                </div>
                               
                                <div class="qhighlight" style="border-radius:5px;padding:8px;margin:10px">
                                    <router-link :to="{ name: 'bookmakercomparison' }"  style="color: black" >
                                        <div><img class="qlargeiconsize qbordericon" :src="require('/public/assets/icons/bookmaker-whi.png')" alt="" ></div>
                                        <div style="margin-top:10px;margin-bottom:10px" >{{ langConv('We compare bookmakers to highlight their pros and cons') }}</div>
                                    </router-link>
                                </div>
                                
                                <div class="qhighlight" style="border-radius:5px;padding:8px;margin:10px">
                                    <router-link :to="{ name: 'fullpagehorsesmouth' }"  style="color: black" >
                                        <div style="color:white;"><img class="qlargeiconsize qbordericon" :src="require('/public/assets/icons/horses-mouth-whi.png')" alt="" id="img0"></div>
                                        <div style="margin-top:10px;margin-bottom:10px" id="title0">{{ langConv('We update you with the latest bookmaker promotions and news') }}</div>
                                    </router-link>
                                </div>
                                
                                <div class="qhighlight" style="border-radius:5px;padding:8px;margin:10px">
                                    <router-link :to="{ name: 'knowledgebase' }"  style="color: black" >
                                         <div><img class="qlargeiconsize qbordericon" :src="require('/public/assets/icons/knowledge-whi.png')" alt="" ></div>
                                         <div style="margin-top:10px;margin-bottom:10px" id="title1">{{ langConv('We share what we know about all things gambling') }}</div>
                                    </router-link>
                                </div>
                               
                                <div class="qhighlight" style="border-radius:5px;padding:8px;margin:10px">
                                    <router-link :to="{ name: 'hutchdutchcalc' }"  style="color: black" >
                                        <div><img class="qlargeiconsize qbordericon" :src="require('/public/assets/icons/betcalc.png')" alt="" ></div>
                                        <div style="margin-top:10px;margin-bottom:10px" >{{ langConv('Use our Bet Calculator to access and store your bets') }}</div>
                                    </router-link>
                                </div>

                            </div>




                        </template>

    <template v-if="orientation=='landscape'">

                
                            <div class="grid-x" style="font-size:14px;font-weight: 500;margin-top:2px;">

                                <div class="cell auto featureblock" >
                                    <router-link :to="{ name: 'graph' }"  style="color: black" >
                                        <div class="hover-wrapper">
                                            <div class="hover-card">
                                                <div class="qmediumlargecircularimage text-center"  style="color:white;margin:0 auto;display:flex;justify-content:center;align-items:center;"><img class="qmediumiconsize qbordericon" :src="require('/public/assets/icons/bet-whi.png')" alt="" id="img0"></div>
                                                <div class="featuretitle" id="title0">{{ langConv('Our Bets') }}</div>
                                            </div>
                                            <div class="hover-content">
                                                {{ langConv('We publish our bets and strategies for you to view') }}

                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                
                                <div class="cell auto featureblock" >
                                    <router-link :to="{ name: 'oddsanalysis' }"  style="color: black" >
                                      <div class="hover-wrapper">
                                            <div class="hover-card">  
                                                <div class="qmediumlargecircularimage text-center"  style="color:white;margin:0 auto;display:flex;justify-content:center;align-items:center;"><img class="qmediumiconsize" :src="require('/public/assets/icons/analytics-whi.png')" alt="" ></div>
                                                <div class="featuretitle" id="title1">{{ langConv('The odds') }}</div>
                                         </div>
                                         <div class="hover-content">
                                                {{ langConv('We compare and analyse the odds') }}

                                         </div>
                                     </div>
                                    </router-link>
                                </div>
                               
                                <div class="cell auto featureblock">
                                    <router-link :to="{ name: 'bookmakercomparison' }"  style="color: black" >
                                        <div class="hover-wrapper">
                                            <div class="hover-card">
                                        <div class="qmediumlargecircularimage text-center"  style="color:white;margin:0 auto;display:flex;justify-content:center;align-items:center;"><img class="qmediumiconsize qbordericon" :src="require('/public/assets/icons/bookmaker-whi.png')" alt="" ></div>
                                        <div class="featuretitle" >{{ langConv('Bookmakers') }}</div>
                                         </div>
                                         <div class="hover-content">
                                                {{ langConv('Compare bookmaker`s pros and cons') }}

                                         </div>
                                     </div>       
                                    
                                    </router-link>
                                </div>
                                
                                <div class="cell auto featureblock" >

                                    <router-link :to="{ name: 'fullpagehorsesmouth' }"  style="color: black" >
                                        <div class="hover-wrapper">
                                            <div class="hover-card">
                                        <div class="qmediumlargecircularimage text-center"  style="color:white;margin:0 auto;display:flex;justify-content:center;align-items:center;"><img class="qmediumiconsize" :src="require('/public/assets/icons/horses-mouth.png')" alt="" id="img0"></div>
                                        <div class="featuretitle" id="title0">{{ langConv('Bookmaker News') }}</div>
                                    </div>
                                         <div class="hover-content">
                                                {{ langConv('The latest bookmaker promotions and news') }}

                                         </div>
                                     </div>
                                    
                                    </router-link>
                                </div>
                                
                                <div class="cell auto featureblock" >
                                    <router-link :to="{ name: 'knowledgebase' }"  style="color: black" >
                                        <div class="hover-wrapper">
                                            <div class="hover-card">
                                         <div class="qmediumlargecircularimage text-center"  style="color:white;margin:0 auto;display:flex;justify-content:center;align-items:center;"><img class="qmediumiconsize qbordericon" :src="require('/public/assets/icons/knowledge-whi.png')" alt="" ></div>
                                         <div  class="featuretitle" id="title1">{{ langConv('Knowledge') }}</div>
                                          </div>
                                         <div class="hover-content">
                                                {{ langConv('We share what we know about all things gambling') }}

                                         </div>
                                     </div>      
                                        </router-link>
                                </div>
                               
                                <div class="cell auto featureblock" >
                                    <router-link :to="{ name: 'hutchdutchcalc' }"  style="color: black" >
                                        <div class="hover-wrapper">
                                            <div class="hover-card">
                                        <div class="qmediumlargecircularimage text-center"  style="color:white;margin:0 auto;display:flex;justify-content:center;align-items:center;"><img class="qmediumiconsize qbordericon" :src="require('/public/assets/icons/betcalc.png')" alt="" ></div>
                                        <div  class="featuretitle">{{ langConv('Betting tools') }}</div>
                                              </div>
                                         <div class="hover-content">
                                                {{ langConv('We have our own calculator for complex bets') }}

                                         </div>
                                     </div>  
                                    
                                    </router-link>
                                </div>

                                <div class="cell auto featureblock" >
                                    <router-link :to="{ name: 'betfinder' }"  style="color: black" >
                                        <div class="hover-wrapper">
                                            <div class="hover-card">
                                        <div class="qmediumlargecircularimage text-center"  style="color:white;margin:0 auto;display:flex;justify-content:center;align-items:center;"><img class="qlargeiconsize qbordericon"  :src="require('/public/assets/icons/betfinder.png')" alt="" ></div>
                                        <div class="featuretitle">{{ langConv('BetFinder') }}</div>
                                    </div>
                                         <div class="hover-content">
                                                {{ langConv('A Bet Finder to find events with your specific criteria') }}

                                         </div>
                                     </div>
                                    
                                    </router-link>
                                </div>

                            </div>



                            
                        </template>

    </div>


</template>

<script>
    export default {

    name: "whatwedo",
    props:  {
        orientation: {
            type: String,
            default: "portrait"
        }
    }

    }
</script>

<style scoped>

.featureblock {
    border:3px solid white;
    padding:0px;
}

.featuretitle {
    margin-top:8px;margin-bottom:0px
}

.hover-wrapper {
    position: relative;
    display: inline-block;
    width: 100%
}

.hover-card {
   
    /* padding: 20px; */
    border-radius: 12px;
    cursor: pointer;
    padding:10px;
}

/* Hidden floating panel */
.hover-content {
    position: absolute;
    top: 100%;
    left: 0;

    width: 100%;
    background: white;

    border-radius: 12px;
    padding: 20px;

    box-shadow: 0 10px 25px rgba(0,0,0,0.15);

    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);

    transition: all 0.25s ease;

    z-index: 999;
}

/* Show on hover */
.hover-wrapper:hover .hover-content {
    opacity: 1;
    visibility: visible;
    transform: translateY(10px);
}


</style>